import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { DISCOVERY_ROUTES, ROUTES, getNestedDiscoveryPath } from '../constants/routes';
import { DiscoveryDashboard } from '../pages/Discovery/Dashboard';
import { Inventory } from '../pages/Discovery/Inventory';
import { MoveGroupsAndApps } from '../pages/Discovery/MoveGroupsAndApps';
import { RVTools } from '../pages/Discovery/RVTools';
import { RMMA } from '../pages/Discovery/Import/RMMA';
import { RMUtilities } from '../pages/Discovery/Import/RMUtilities';
import { NewRelic } from '../pages/Discovery/Import/NewRelic';
import { isDiscoveryEnabled } from '../layout/sidebar/hooks/useNavigation';

// Constants for nested discovery paths
const NESTED_INVENTORY_PATH = getNestedDiscoveryPath(DISCOVERY_ROUTES.inventory);
const NESTED_MOVE_GROUPS_APPS_PATH = getNestedDiscoveryPath(DISCOVERY_ROUTES.moveGroupsAndApps);
const NESTED_RVTOOLS_PATH = getNestedDiscoveryPath(DISCOVERY_ROUTES.rvTools);
// const NESTED_RMMA_PATH = getNestedDiscoveryPath(DISCOVERY_ROUTES.rmma);
// const NESTED_RMUTILITIES_PATH = getNestedDiscoveryPath(DISCOVERY_ROUTES.rmUtilities);
// const NESTED_NEWRELIC_PATH = getNestedDiscoveryPath(DISCOVERY_ROUTES.newRelic);

// Discovery router component that handles nested routes
const DiscoveryRouter = () => {
    return (
        <Routes>
            {/* Base discovery route */}
            <Route index element={<DiscoveryDashboard />} />
            {/* Inventory route */}
            <Route path={NESTED_INVENTORY_PATH} element={<Inventory />} />
            {/* Move Groups and Apps route */}
            <Route path={NESTED_MOVE_GROUPS_APPS_PATH} element={<MoveGroupsAndApps />} />
            {/* Import routes */}
            <Route path={NESTED_RVTOOLS_PATH} element={<RVTools />} />
            {/* <Route path={NESTED_RMMA_PATH} element={<RMMA />} />
      <Route path={NESTED_RMUTILITIES_PATH} element={<RMUtilities />} />
      <Route path={NESTED_NEWRELIC_PATH} element={<NewRelic />} /> */}
        </Routes>
    );
};

export const DiscoveryRoutes = () => {
    // Check if discovery feature is enabled
    const DISCOVERY_FEATURE_ENABLED = isDiscoveryEnabled();
    if (!DISCOVERY_FEATURE_ENABLED) {
        return <Route path={`${DISCOVERY_ROUTES.base}/*`} element={<Navigate to={ROUTES.home} replace />} />;
    }

    return <Route path={`${DISCOVERY_ROUTES.base}/*`} element={<DiscoveryRouter />} />;
};
